import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../Firebase";
import Loading from "../components/Loading";

const IndividualBlog = () => {
  const { blogId } = useParams();

  const [blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getBlog() {
    setLoading(true);
    const docRef = doc(db, "blog", blogId);
    await getDoc(docRef).then((response) => {
      setBlog(response.data());
    });
    setLoading(false);
  }

  useEffect(() => {
    getBlog();
  }, []);

  if (loading === true) {
    return <Loading />;
  }

  return (
    <>
      <div id="container">
        <div className="max-w-[1440px] w-full flex flex-col p-4 mt-40">
          <div className="flex flex-col items-center space-y-8">
            <div className="max-w-4xl space-y-4">
              <h1 className="lg:text-4xl text-2xl font-bold">{blog?.title}</h1>
              <div className="space-x-10">
                <small>postedBy: {blog?.postedBy}</small>
                <small>
                  Date:
                  {new Date(blog?.created?.seconds * 1000).toLocaleDateString(
                    "en-US"
                  )}
                </small>
              </div>
            </div>
            <div className="w-full h-60 lg:max-w-[1200px] lg:h-[500px]">
              <img
                className="w-full h-full object-cover rounded-lg"
                src={blog?.img}
                alt={blog?.img}
              />
            </div>
            <div className="space-y-10 max-w-4xl">
              <p>{blog?.para}</p>
              <p>{blog?.para1}</p>
              <p>{blog?.para2}</p>
              <p>{blog?.para3}</p>
              <p>{blog?.para4}</p>
              <p>{blog?.para5}</p>
              <p>{blog?.para6}</p>
              <p>{blog?.para7}</p>
              <p>{blog?.para8}</p>
              <p>{blog?.para9}</p>
              <p>{blog?.para10}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndividualBlog;
